import * as React from "react";

/**
 * Form-mode context shared by the section components. The create wizard
 * (`PostingForm`) leaves this at its default ("create"); the single-page
 * `EditPostingForm` provides edit-only constraints so sections can lock the
 * controls the API will reject (position / employment type are immutable,
 * a work location with booked interviews can't be detached, headcount can't
 * drop below confirmed hires).
 */
export interface PostingFormMode {
  mode: "create" | "edit";
  /** Position is immutable after publish — render it read-only. */
  lockPosition?: boolean;
  /** Employment type is immutable after publish — render it read-only. */
  lockEmploymentType?: boolean;
  /** Floor for the headcount stepper (= committed hires). */
  minHeadcount?: number;
  /** orgAddressIds that cannot be deselected (active interviews booked). */
  lockedAddressIds?: string[];
  /** Per-address active-interview count, for the lock hint. */
  addressInterviewCounts?: Record<string, number>;
  /**
   * Admin-only: render the Facebook source-link field. Off by default so the
   * employer create/edit forms never expose it.
   */
  showSourceUrl?: boolean;
}

const DEFAULT_MODE: PostingFormMode = { mode: "create" };

const PostingFormModeContext =
  React.createContext<PostingFormMode>(DEFAULT_MODE);

export const PostingFormModeProvider = PostingFormModeContext.Provider;

export function usePostingFormMode(): PostingFormMode {
  return React.useContext(PostingFormModeContext);
}
